import React from 'react';
import { Link } from 'react-router-dom';
import abimg from '../../images/about.jpg';
import spimg1 from '../../images/ab-shape-1.png';
import spimg2 from '../../images/ab-shape-2.png';
import spicon from '../../images/icon/badge.svg';
import './About.css'; // Archivo CSS para estilos personalizados

const About = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <section className={`wpo-about-section ${props.abClass}`}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-12 col-12">
                        <div className="wpo-about-wrap">
                            <div className="wpo-about-img">
                                <img src={abimg} alt="" />
                                <div className="wpo-ab-shape-1"><img src={spimg1} alt="" /></div>
                                <div className="wpo-ab-shape-2"><img src={spimg2} alt="" /></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                        <div className="wpo-about-text">
                            <div className="wpo-about-icon">
                                <div className="icon">
                                    <img src={spicon} alt="" />
                                </div>
                            </div>
                            <div className="wpo-about-icon-content">
                                <h2>Profesionales en optimización <span>de procesos empresariales.</span></h2>
                                <p>
                                    Ofrecemos soluciones integrales para mejorar el rendimiento de tu empresa, incluyendo el desarrollo de software a medida, consultoría en automatización de procesos, capacitación en herramientas TIC y asesoría personalizada. Nos enfocamos en optimizar procesos, aumentar la productividad y potenciar las habilidades tecnológicas de tu equipo, siempre alineando nuestras soluciones con tus objetivos estratégicos.
                                </p>
                                <p className="highlight-text">
                                    ¡Transformamos tecnología en soluciones y desafíos en resultados!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;